export default {
  effects: {
    captions: {
      blur: 'ぼかし',
      crop: 'トリミング',
      enhance: '補正',
      flip: '反転',
      grayscale: 'グレースケール',
      invert: '階調反転',
      mirror: 'ミラー',
      rotate: '回転',
      sharp: 'シャープ',
    },
    apply: '適用',
  },
}
